if (!customElements.get('product-accordion-drawer')) {
  class ProductAccordionDrawer extends HTMLElement {
    connectedCallback() {
      if (this.parentElement !== document.body) {
        /* A morph can deliver a second copy of a drawer that already relocated itself,
           leaving two elements on one id. `getElementById` would return the newcomer,
           still inside the section and earlier in document order. */
        const existing = [...document.body.children].find(
          (element) => element !== this && element.tagName === this.tagName && element.id === this.id
        );
        existing?.remove();

        document.body.appendChild(this);
        return;
      }

      const id = this.id;
      const drawer = this.querySelector('.drawer');
      const overlay = this.querySelector('[data-drawer-overlay]');
      const closeBtn = this.querySelector('[data-drawer-close]');

      this._documentClickHandler = (e) => {
        const trigger = e.target.closest(`[data-drawer-target="${id}"]`);
        if (trigger) {
          e.preventDefault();
          this.toggle(true, drawer, overlay);
        }
      };

      document.addEventListener('click', this._documentClickHandler);

      if (closeBtn) {
        closeBtn.addEventListener('click', () => this.toggle(false, drawer, overlay));
      }

      if (overlay) {
        overlay.addEventListener('click', () => this.toggle(false, drawer, overlay));
      }
    }

    disconnectedCallback() {
      document.body.style.overflow = '';
      if (this._documentClickHandler) {
        document.removeEventListener('click', this._documentClickHandler);
      }
    }

    toggle(open, drawer, overlay) {
      const val = open ? 'true' : 'false';
      if (drawer) drawer.setAttribute('data-open', val);
      if (overlay) overlay.setAttribute('data-open', val);
      document.body.style.overflow = open ? 'hidden' : '';
    }
  }

  customElements.define('product-accordion-drawer', ProductAccordionDrawer);
}
